import { render, staticRenderFns } from "./CustomerOrderPage.vue?vue&type=template&id=6ff387e4&scoped=true&"
import script from "./CustomerOrderPage.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff387e4",
  null
  
)

export default component.exports